import React from 'react'
import PropTypes from 'prop-types'

import { Typography } from '@material-ui/core'

import { TrackButton } from 'artkive/components/Tracker'
import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import useSale from 'artkive/hooks/useSale'

import {
  BodyWrapper,
  CtaRow,
  Photo,
  PhotoColumn,
  PhotoWrapper,
  QuoteAuthor,
  QuoteCard,
  QuoteMark,
  Row,
  Section,
  TextColumn,
  Title,
} from './FeatureQuoteSection.style'
import { MOBILE_IMAGE_RATIO } from './Keepsakes.constants'
import Phrases from './Phrases'

const IMAGE_RATIO = 580 / 480

const FeatureQuoteSection = ({ title, titleWidth, body, image, quote, cta, ...rest }) => {
  const isMobile = useMobileBreakpoint()
  const { boxCheckoutUrl } = useSale()

  const intro = (
    <>
      <Title variant='h2' align={isMobile ? 'center' : 'left'} titleWidth={titleWidth}>
        <Phrases text={title} />
      </Title>
      <BodyWrapper>
        <Typography variant='body1' align={isMobile ? 'center' : 'inherit'}>
          {body}
        </Typography>
      </BodyWrapper>
    </>
  )

  const photo = <Photo ratio={isMobile ? MOBILE_IMAGE_RATIO : IMAGE_RATIO} src={image.image} alt={image.alt} />

  const quoteAndCta = (
    <>
      <QuoteCard>
        <QuoteMark component='span' aria-hidden='true'>
          &ldquo;
        </QuoteMark>
        <Typography variant='body1'>{quote.text}</Typography>
        <QuoteAuthor variant='body1'>{quote.author}</QuoteAuthor>
      </QuoteCard>
      <CtaRow>
        <TrackButton
          color='primary'
          href={boxCheckoutUrl}
          size='large'
          variant='contained'
          trackerEvent={GET_BOX_CLICK}
          trackerOptions={{ section: cta.section }}
        >
          {cta.label}
        </TrackButton>
      </CtaRow>
    </>
  )

  return (
    <Section {...rest}>
      {isMobile ? (
        <div>
          {intro}
          <PhotoWrapper>{photo}</PhotoWrapper>
          {quoteAndCta}
        </div>
      ) : (
        <Row>
          <PhotoColumn>{photo}</PhotoColumn>
          <TextColumn>
            {intro}
            {quoteAndCta}
          </TextColumn>
        </Row>
      )}
    </Section>
  )
}

FeatureQuoteSection.propTypes = {
  title: PropTypes.string.isRequired,
  titleWidth: PropTypes.number,
  body: PropTypes.string.isRequired,
  image: PropTypes.shape({
    image: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  quote: PropTypes.shape({
    text: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
  }).isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    section: PropTypes.string.isRequired,
  }).isRequired,
}

export default FeatureQuoteSection
